import React from 'react';
import Image from 'next/legacy/image';

import { IPagePointerFields } from '../../../types/contentful';

import Link from '../Link';
import { Box } from '../Box';
import { UnstyledButton } from '../Button';

import { BoxWithBorder, IconWrapper, LegalText } from './styles';

import rightArrowIcon from '@/images/right-arrow-icon.svg';

export function PagePointer({ title, url }: IPagePointerFields) {
  return (
    <BoxWithBorder padding={{ 0: ['collapsibleVert', 0], tablet: ['l', 0] }}>
      <LegalText as="h3" fontWeight="h3" data-testid="page-pointer-header">
        <Link href={url} style={{ textDecoration: 'none', color: '#000' }}>
          {title}
        </Link>
      </LegalText>
      <Box
        paddingLeft={{ 0: 's', tablet: 'm' }}
        paddingTop={{ 0: '2xs', tablet: 'xs' }}
      >
        <UnstyledButton>
          <Box padding="xs">
            <Link href={url}>
              <IconWrapper>
                <Image src={rightArrowIcon} alt="" />
              </IconWrapper>
            </Link>
          </Box>
        </UnstyledButton>
      </Box>
    </BoxWithBorder>
  );
}
